import { render, staticRenderFns } from "./saomalog.vue?vue&type=template&id=6ccc68de&scoped=true&"
import script from "./saomalog.vue?vue&type=script&lang=js&"
export * from "./saomalog.vue?vue&type=script&lang=js&"
import style0 from "./saomalog.vue?vue&type=style&index=0&id=6ccc68de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc68de",
  null
  
)

export default component.exports